import React from "react";
import SEO from "../components/SEO";
import { getBreadcrumbSchema } from "../utils/schema";
import "./Legal.css";

export const Cookies = () => {
  const breadcrumbSchema = getBreadcrumbSchema([
    { name: 'Home', url: '/' },
    { name: 'Cookie Policy', url: '/cookies' }
  ]);

  return (
    <div className="legal-page">
      <SEO
        title="Cookie Policy | Brightson Accounting Limited"
        description="Cookie policy for Brightson Accounting Limited. Learn about cookies used on our website."
        canonical="/cookies"
        schema={breadcrumbSchema}
      />
      
      <section className="legal-hero">
        <div className="container">
          <h1>Cookie Policy</h1>
          <p className="legal-updated">Last updated: December 2025</p>
        </div>
      </section>

      <section className="legal-content">
        <div className="container">
          <div className="legal-text">
            <h2>1. What Are Cookies</h2>
            <p>
              Cookies are small text files stored on your device when you visit a website. They help 
              websites remember your preferences and improve your browsing experience.
            </p>

            <h2>2. How We Use Cookies</h2>
            <p>
              Our website uses only essential cookies necessary for the website to function properly. 
              We do not use tracking, advertising, or analytics cookies that collect personal data.
            </p>

            <h2>3. Types of Cookies We Use</h2>
            
            <h3>Essential Cookies</h3>
            <p>
              These cookies are necessary for the website to function and cannot be disabled. They include:
            </p>
            <ul>
              <li><strong>Session cookies:</strong> Maintain your session as you navigate between pages</li>
              <li><strong>Security cookies:</strong> Help keep our website secure</li>
            </ul>

            <h2>4. Third-Party Cookies</h2>
            <p>
              Our website may contain links to third-party websites (such as professional body websites 
              referenced in our About page). These third parties may set their own cookies. We do not 
              control these cookies and recommend reviewing their cookie policies.
            </p>

            <h2>5. Managing Cookies</h2>
            <p>
              You can control and manage cookies through your browser settings. However, disabling 
              essential cookies may affect the functionality of our website.
            </p>
            
            <h3>How to Manage Cookies in Your Browser:</h3>
            <ul>
              <li><strong>Google Chrome:</strong> Settings → Privacy and security → Cookies and other site data</li>
              <li><strong>Firefox:</strong> Settings → Privacy & Security → Cookies and Site Data</li>
              <li><strong>Safari:</strong> Preferences → Privacy → Cookies and website data</li>
              <li><strong>Edge:</strong> Settings → Cookies and site permissions → Cookies and site data</li>
            </ul>

            <h2>6. Cookie Duration</h2>
            <p>
              Essential cookies on our website are session cookies that expire when you close your 
              browser or after a period of inactivity.
            </p>

            <h2>7. Updates to This Policy</h2>
            <p>
              We may update this Cookie Policy from time to time. Any changes will be posted on this 
              page with an updated revision date.
            </p>

            <h2>8. Contact Us</h2>
            <p>
              If you have questions about our use of cookies, please contact us:
            </p>
            <p>
              <strong>Email:</strong> <a href="mailto:info@brightsonaccounting.co.uk">info@brightsonaccounting.co.uk</a><br/>
              <strong>Registered Office:</strong> 71-75 Shelton Street, Covent Garden, London, United Kingdom, WC2H 9JQ<br/>
              <strong>Service area:</strong> Serving Wolverhampton and the West Midlands
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Cookies;
